<div class="infos">
  @if (!parentComponent?.editTabs?.[0]?.data?.isView) {
    <div class="info">
      <label>{{ 'editView.createdBy' | translate }}</label> {{ auditsInfo.created_by }}
    </div>
    <div class="info">
      <label>{{ 'editView.updatedBy' | translate }}</label> {{ auditsInfo.updated_by }}
    </div>
  }
  <div class="info">
    @if (auditsInfo.id_txt !== '') {
      <button
        class="p-button p-button-secondary"
        icon="icon-copy"
        pButton
        type="button"
        [hideDelay]="250"
        [life]="3000"
        pTooltip="{{ 'editView.copyToClipBoard' | translate }}"
        (click)="copyToClipBoard(auditsInfo.id_txt)"></button>
    }
    <div>
      <label>ID ({{ auditsInfo.tableName }})</label>
      <p style="white-space: initial">{{ auditsInfo.id_txt }}</p>
    </div>
  </div>
</div>

@if (isCopiedToClipBoard) {
  <div class="changelog-copied-to-clipboard">
    {{ 'editView.copyToClipBoardMsg' | translate }}
  </div>
}

@if (tableDisplayed) {
  <div class="table">
    <apiz-grid-headless
      #grid
      class="apiz-grid-headless"
      [cacheRowCount]="cacheBlockSize"
      [columnDefs]="headerCols"
      [getContextMenuItems]="getContextMenuItems"
      [initAutosizeBehavior]="'min-content'"
      [pagination]="true"
      [paginationPageCountOption]="10"
      [paginationPageCountOptions]="[10, 20, 30, 40, 50, 'AUTO']"
      [rowMultiSelectWithClick]="false"
      [rowSelectionOnCellClicked]="false" />
  </div>
}
